import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { FolderIcon } from "@heroicons/react/24/outline";
import { FolderItem } from "@/types/fse";
import { FlattenedItem } from "@/views/chat/types";

interface FolderItemProps {
  item: FlattenedItem & FolderItem;
  toggleFolder: (folderId: string) => void;
}

export const FolderItemComponent: React.FC<FolderItemProps> = ({ item, toggleFolder }) => (
  <div className="flex flex-col py-2" style={{ paddingLeft: `${item.depth * 10}px` }}>
    <div className="flex items-center">
      <div className="flex flex-grow cursor-pointer items-center" onClick={() => toggleFolder(item.id)}>
        <span className="mr-1">{item.isExpanded ? <ChevronDown size={14} /> : <ChevronUp size={14} />}</span>
        <FolderIcon className="mr-2 h-4 w-4 flex-shrink-0 text-desert-sand-800" />
        <span className="text-color-text-ui-heading-text break-all pr-2 text-sm">{item.name}</span>
      </div>
    </div>
  </div>
);
